import React from 'react';
import { Box, Grid } from '@mui/material';
import useResponsive from 'hooks/useResponsive';
import { LoginForm } from 'containers/forms';

const Login = () => {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Grid
      container
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      sx={{ height: '100vh' }}
    >
      <Grid item xs={6}>
        <LoginForm />
      </Grid>

      {isDesktop && (
        <Grid
          item
          xs={6}
          sx={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box sx={{ width: 850 }}>
            <img src="/images/login-background.svg" alt="login-background" style={{ borderRadius: '16px' }} />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default Login;
